import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'app-request-info-payment-modal',
    templateUrl: './request-info-payment-modal.component.html',
    styleUrls: ['./request-info-payment-modal.component.css']
})
export class RequestInfoPaymentModalComponent implements OnInit {
    paymentDetails: string = '';

    constructor(public activeModal: NgbActiveModal,) {}

    ngOnInit(): void {
    }

}
